<template>
    <div style="width: 100%">
<!--        <h5 v-if="!oracle.isEmpty(lawyer.lawyer_content) && lawyer.lawyer_content.length > 3" class="font-weight-bold">{{language.lang('About Me')}}</h5>-->
        <!--        <p class="mb-3" v-if="!oracle.isEmpty(lawyer.lawyer_description)">{{lawyer.lawyer_description}}</p>-->
<!--        <span v-if="!oracle.isEmpty(lawyer.lawyer_content) && lawyer.lawyer_content.length > 3" class="html-content"-->
<!--              v-html="lawyer.lawyer_content"></span>-->
        <h5 v-if="!oracle.isEmpty(lawyer.lawyer_init_fee)" class="font-weight-bold">
            {{language.lang('Initial Consultation')}}</h5>
        <span v-if="!oracle.isEmpty(lawyer.lawyer_init_fee)" role="button"  class="shadow" :class="isEN ? 'tag-item' : 'tag-item-fa'">
            {{lawyer.lawyer_init_fee}}</span>
        <h5 v-if="!oracle.isEmpty(lawyer.lawyer_specializations)" class="font-weight-bold mt-3">
            {{language.lang('Specialization')}}</h5>
        <div v-if="!oracle.isEmpty(lawyer.lawyer_specializations)" class="d-flex flex-wrap mb-3">
                                        <span role="button" class="shadow" :class="isEN ? 'tag-item' : 'tag-item-fa'"
                                              v-for="(item, index) in lawyer.lawyer_specializations"
                                              :key="index">{{language.lang(item)}}</span>
        </div>
        <h5 v-if="!oracle.isEmpty(lawyer.lawyer_languages)" class="font-weight-bold">{{language.lang('Languages')}}</h5>
        <div v-if="!oracle.isEmpty(lawyer.lawyer_languages)" class="d-flex flex-wrap mb-3">
                                        <span role="button" class="shadow" :class="isEN ? 'tag-item' : 'tag-item-fa'"
                                              v-for="(item, index) in lawyer.lawyer_languages"
                                              :key="index">{{language.lang(item)}}</span>
        </div>
        <h5 v-if="!oracle.isEmpty(lawyer.lawyer_services)" class="font-weight-bold">{{language.lang('Services')}}</h5>
        <div v-if="!oracle.isEmpty(lawyer.lawyer_services)" class="d-flex flex-wrap mb-3">
                                        <span role="button" class="shadow" :class="isEN ? 'tag-item' : 'tag-item-fa'"
                                              v-for="(item, index) in lawyer.lawyer_services"
                                              :key="index">{{language.lang(item)}}</span>
        </div>
    </div>
</template>
<script>
    import oracle from "@/utils/oracle";
    import language from "@/utils/language";

    export default {
        props: {
            lawyer: Object
        },
        data: () => ({
            oracle: oracle,
            language: language,
            isEN: oracle.isEN(),
        }),
        mounted() {

        }
    };
</script>
<style>
</style>
